import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { storeGet, STORE_KEY_ACCOUNT } from 'mailup-react-helpers'
import {
  advancedPaddingState,
  customStyleState,
  defaultStyleState,
  modalConfirmDiscardState,
  pageState,
  styleState
} from '../state/state'
import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'
import {
  saveContentDefaults,
  enabledContentDefaults,
  getContentDefaults
} from '../actions/actions'

export const resetCallback = ({ set, reset }) => async () => {
  reset(pageState)
  reset(defaultStyleState)
  reset(styleState)
}

export const initCallback = ({ set, reset, snapshot }) => async () => {
  try {
    const account = storeGet(STORE_KEY_ACCOUNT)
    set(pageState, prev => ({
      ...prev,
      isEnabled: account.IdOffer !== 3 && account.IdOffer !== 2 && !account.IsOfferLight,
      loading: true,
      loaded: false
    }))

    const defaultStyle = await snapshot.getPromise(defaultStyleState)

    const resp = await getContentDefaults()

    if (resp && resp.Enable) {
      const enableObj = JSON.parse(resp.Enable)
      if (enableObj.EnableAll) {
        set(customStyleState, prev => ({
          ...prev,
          enabledAll: true
        }))
      }
    }

    if (resp && resp.Configuration) {
      const configurationObj = JSON.parse(resp.Configuration)
      set(styleState, configurationObj)

      set(advancedPaddingState, prev => ({
        ...prev,
        // BUTTON
        buttonDesktopPaddingAdvanced:
          configurationObj.button.styles.paddingTop !==
            configurationObj.button.styles.paddingBottom ||
          configurationObj.button.styles.paddingLeft !==
            configurationObj.button.styles.paddingRight,
        buttonDesktopBlockAdvanced:
          configurationObj.button.blockOptions.paddingTop !==
            configurationObj.button.blockOptions.paddingBottom ||
          configurationObj.button.blockOptions.paddingLeft !==
            configurationObj.button.blockOptions.paddingRight,
        buttonMobilePaddingAdvanced:
          configurationObj.button.mobileStyles.paddingTop !==
            configurationObj.button.blockOptions.paddingTop ||
          configurationObj.button.mobileStyles.paddingBottom !==
            configurationObj.button.blockOptions.paddingBottom ||
          configurationObj.button.mobileStyles.paddingLeft !==
            configurationObj.button.blockOptions.paddingLeft ||
          configurationObj.button.mobileStyles.paddingRight !==
            configurationObj.button.blockOptions.paddingRight,

        // paragraph
        paragraphDesktopPaddingAdvanced:
          configurationObj.paragraph.blockOptions.paddingTop !==
            configurationObj.paragraph.blockOptions.paddingBottom ||
          configurationObj.paragraph.blockOptions.paddingLeft !==
            configurationObj.paragraph.blockOptions.paddingRight,
        paragraphMobilePaddingAdvanced:
          configurationObj.paragraph.mobileStyles.paddingTop !==
            configurationObj.paragraph.blockOptions.paddingTop ||
          configurationObj.paragraph.mobileStyles.paddingBottom !==
            configurationObj.paragraph.blockOptions.paddingBottom ||
          configurationObj.paragraph.mobileStyles.paddingLeft !==
            configurationObj.paragraph.blockOptions.paddingLeft ||
          configurationObj.paragraph.mobileStyles.paddingRight !==
            configurationObj.paragraph.blockOptions.paddingRight,
        // social
        socialDesktopPaddingAdvanced:
          configurationObj.social.blockOptions.paddingTop !==
            configurationObj.social.blockOptions.paddingBottom ||
          configurationObj.social.blockOptions.paddingLeft !==
            configurationObj.social.blockOptions.paddingRight,
        socialMobilePaddingAdvanced:
          configurationObj.social.mobileStyles.paddingTop !==
            configurationObj.social.blockOptions.paddingTop ||
          configurationObj.social.mobileStyles.paddingBottom !==
            configurationObj.social.blockOptions.paddingBottom ||
          configurationObj.social.mobileStyles.paddingLeft !==
            configurationObj.social.blockOptions.paddingLeft ||
          configurationObj.social.mobileStyles.paddingRight !==
            configurationObj.social.blockOptions.paddingRight
      }))
    } else {
      set(styleState, defaultStyle)
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmaiContentDefault',
      Method: 'initCallback'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({
    ...prev,
    loaded: true,
    loading: false
  }))
}

export const saveCallback = ({ set, snapshot }) => async () => {
  try {
    const style = await snapshot.getPromise(styleState)

    await saveContentDefaults({
      Configuration: JSON.stringify(style)
    })

    set(pageState, prev => ({
      ...prev,
      isDirty: false
    }))

    toastShow(
      getIntl().formatMessage({
        id: 'Load.ContentDefaults.SuccessSaved'
      }),
      TOAST_VARIANT_SUCCESS,
      'SuccessSaved'
    )
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmaiContentDefault',
      Method: 'saveCallback'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const discardCallback = ({ set, reset, snapshot }) => async () => {
  try {
    set(pageState, prev => ({
      ...prev,
      loading: true
    }))

    const defaultStyle = await snapshot.getPromise(defaultStyleState)

    await saveContentDefaults({
      Configuration: JSON.stringify(defaultStyle)
    })
    set(styleState, defaultStyle)
    set(pageState, prev => ({
      ...prev,
      isDirty: false
    }))

    toastShow(
      getIntl().formatMessage({
        id: 'Load.ContentDefaults.SuccessStyleReset'
      }),
      TOAST_VARIANT_SUCCESS,
      'SuccessStyleReset'
    )

    reset(modalConfirmDiscardState)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmaiContentDefault',
      Method: 'discardCallback'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const enableAllCallback = ({ set, reset, snapshot }) => async value => {
  try {
    set(pageState, prev => ({
      ...prev,
      loading: true
    }))
    await enabledContentDefaults({
      Enable: JSON.stringify({ EnableAll: value, ContentsEnable: [] })
    })

    toastShow(
      getIntl().formatMessage({
        id: value
          ? 'Load.ContentDefaults.SuccessApplied'
          : 'Load.ContentDefaults.SuccessDisabled'
      }),
      TOAST_VARIANT_SUCCESS
      // value ? 'SuccessApplied' : 'SuccessDisabled'
    )

    reset(modalConfirmDiscardState)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmaiContentDefault',
      Method: 'discardCallback'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}
